import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'aa-filter-sub-title',
    templateUrl: './filter-sub-title.component.html',
    styleUrls: [
        './filter-sub-title.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FilterSubTitleComponent implements OnInit
{
    @Input() isFirst: boolean = false;

    constructor() { }

    ngOnInit ()
    {
    }
}
